module.exports = __webpack_public_path__ + "6c669ddd17558db9f7bbfeac9a180b1a.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Regular.woff
// module id = 399
// module chunks = 0